module.exports = __webpack_public_path__ + "static/media/Bloodbag.4b2037c7.png";